import { createClient } from '@liveblocks/client';
import { createRoomContext } from '@liveblocks/react';

import { getRunAddress } from '@/core/apiConfig';
import { getUsersSettings } from '@/domain/userSettings/userSettingsApi';
import { getCollectionShares, getMockupShares } from '@/domain/mockups/mockupsShareApi';

export const actualRoom = { id: '' };

export const liveblocksClient = createClient({
  authEndpoint: async room => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const response = await fetch(`${getRunAddress()}/liveblocks-proxy/v1/liveblocks/decorator`, {
      credentials: 'include',
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({ room }),
    });

    return response.json();
  },
  resolveUsers: async ({ userIds }) => {
    const usersData = await getUsersSettings(userIds);

    return usersData.map((userData: any) => ({
      name: userData.displayName,
      avatar: userData.photoURL,
    }));
  },
  resolveMentionSuggestions: async ({ text, roomId }) => {
    const type = roomId.match('collection') ? 'collection' : 'mockup';
    const id = type === 'collection' ? roomId.replace('collection_', '') : roomId;
    const sharesFetcher = type === 'collection' ? getCollectionShares : getMockupShares;
    const usersList = await sharesFetcher(id);
    const usersIds = usersList.map(({ userId }) => userId);
    const roomUsersMap = await getUsersSettings(usersIds);

    if (!text) {
      // Show all workspace users by default
      return roomUsersMap.map(({ uid }) => uid);
    } else {
      return roomUsersMap
        .filter(({ displayName }) =>
          (displayName || '').toLowerCase().includes((text || '').toLowerCase()),
        )
        .map(({ uid }) => uid);
    }
  },
});

type Presence = {};
type Storage = {};
type UserMeta = {};
type RoomEvent = {};
type ThreadMetadata = {
  resolved: boolean;
};

export const { RoomProvider } = createRoomContext<
  Presence,
  Storage,
  UserMeta,
  RoomEvent,
  ThreadMetadata
>(liveblocksClient);
